interface Review {
  user: string;
  score: number;
  text: string;
}

interface AudienceReviewsProps {
  reviews: Review[];
}

export default function AudienceReviews({ reviews }: AudienceReviewsProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center gap-2 mb-5">
        <span className="w-1.5 h-5 rounded-full bg-secondary-500"></span>
        <h2 className="text-lg font-heading font-bold text-foreground-950">观众反馈（演示）</h2>
      </div>
      <div className="space-y-4">
        {reviews.map((r, i) => (
          <div key={i} className="pb-4 border-b border-background-200 last:border-0 last:pb-0">
            <div className="flex items-center gap-3 mb-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-semibold">
                {r.user.slice(0, 1)}
              </span>
              <span className="text-sm font-medium text-foreground-800">{r.user}</span>
              <span className="ml-auto inline-flex items-center gap-1 text-xs text-secondary-700">
                <i className="ri-star-fill"></i>
                {r.score.toFixed(1)}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{r.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}